import {
    Stats,
  } from "react-instantsearch-dom";
  import { useRouter } from "next/compat/router";
import { useEffect, useState } from "react";
import { bodyOverflow } from "@/helpers/userHelpers";
import { useDispatch, useSelector } from "react-redux";
import { nbHitsCount } from "@/redux/actions/nbHitsAction";


  const StatsComp = (props) => {
    const router = useRouter();
    const { query } = router.query;
    const { skeletonRef} = props;
    const [searchData,setSearchData]= useState("")
    const dispatch = useDispatch();
    const nbHitsCountData = useSelector((state) => state.nbHitsCount);
    let pathname = router.pathname;
   useEffect(()=>{
    if(pathname == '/search' && query && !props.filterOnly){
      setSearchData(`Search results for '${query}' `)
    } else if(typeof props.seoData?.header != 'undefined' && props.seoData?.header != ""){
      setSearchData(props.seoData.header);
    }else if(typeof props.brand_name != 'undefined'){
      setSearchData(props.brand_name);
    }else if(typeof props.nav_subcat != 'undefined' && props.nav_subcat != ""){
      setSearchData(props.nav_subcat);
    }else if(typeof props.nav_cat != 'undefined' && props.nav_cat != ""){
      setSearchData(props.nav_cat);
    }else if(typeof props.nav_type != 'undefined' && props.nav_type != ""){
      setSearchData(props.nav_type);
    }else if(props.filterOnly) {
      setSearchData('');
    }else if(searchData == ""){
      setSearchData("")
    }
   })
  
    if(props.type=='load-more'){
      return ( <Stats
      translations={{
        stats(nbHits, processingTimeMS, nbSortedHits, areHitsSorted) {
          return areHitsSorted && nbHits !== nbSortedHits
            ? `${nbSortedHits.toLocaleString()} relevant results sorted out of ${nbHits.toLocaleString()} found in ${processingTimeMS.toLocaleString()}ms`
            : `${nbHits.toLocaleString()} results`;
           
        },
      }}
    /> );
    } 

    else{
      return (
          <>
          <div className="grid-md-12">
            <div className="search-result-count">
              <h1 className="xx-large-md x-large-sm x-large-xs light">{ searchData}</h1>
              <sub className="x-small-sm x-small-md xx-small-xs">
                  <Stats className={searchData==""?'no-plp-heading':''}
                  translations={{
                    stats(nbHits, processingTimeMS, nbSortedHits, areHitsSorted,processingResult) {
                      if(nbHits === 'zero-result') {
                        if(nbHitsCountData.nbHitsCount !== 0){
                          dispatch(nbHitsCount(0))
                        }
                        bodyOverflow();
                        return <div className="loading-result"></div>;
                      }
                      if(nbHits === 0){
                        if(nbHitsCountData.nbHitsCount !== 0){
                          dispatch(nbHitsCount(0))
                        }
                      }
                      skeletonRef?.current.remove();
                      bodyOverflow(false);
                      return areHitsSorted && nbHits !== nbSortedHits
                        ? `${nbSortedHits.toLocaleString()} relevant results sorted out of ${nbHits.toLocaleString()} found in ${processingTimeMS.toLocaleString()}ms`
                        : `${nbHits.toLocaleString()} results `;
                    },
                  }}
                />  
              </sub>       
            </div>         
          </div>
          </>
      );
    }
  };
  
  export default StatsComp;
  